import { render } from "./Apparel.vue?vue&type=template&id=140dd8c1"
import script from "./Apparel.vue?vue&type=script&lang=js"
export * from "./Apparel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__